import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Edit from './edit';

jest.mock('axios');

describe('CompanyGroup', () => {
  describe('Edit', () => {
    test('renders', async() => {

      const m_company_group = {id: 2, name: "company_group_A", group_id: "company_group_id_A"}
      const selected_companies = [ {id: 1, company_name: "company_A"} , {id: 2, company_name: "company_B"} ]
      const m_companies = [ {id: 3, company_name: "company_C"} , {id: 4, company_name: "company_D"} ]

      render(<Edit m_company_group={m_company_group} selected_companies={selected_companies} unselected_companies={m_companies}/>);

      // タイトル
      expect(screen.getByRole("heading", {name: "企業グループ編集"})).toBeInTheDocument();

      // ボタン類
      expect(screen.getByText('更新')).toBeInTheDocument();
      expect(screen.getByText('戻る')).toBeInTheDocument();

      // 入力エリア
      const text1 = screen.getAllByRole("textbox")[0] as HTMLInputElement;
      const text2 = screen.getAllByRole("textbox")[1] as HTMLInputElement;
      expect(text1.value).toBe("company_group_A");
      expect(text2.value).toBe("company_group_id_A");

      // 企業一覧
      expect(screen.getByText('company_A')).toBeInTheDocument();
      expect(screen.getByText('company_B')).toBeInTheDocument();
      expect(screen.getByText('company_C')).toBeInTheDocument();
      expect(screen.getByText('company_D')).toBeInTheDocument();
    });  
  }); 
});